import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ActivityIcon, BrainIcon, LayoutListIcon, CheckIcon } from 'lucide-react';
export function IncludesSection() {
  const categories = [{
    title: 'CUERPO',
    icon: <ActivityIcon className="w-6 h-6 text-sand" data-id="element-140" />,
    items: ['Plan de comida real 7 días (carnívoro limpio)', 'Lista de compras simple', 'Comidas repetibles (sin pensar)', 'Protocolo de antojos (90 segundos)', 'Protocolo de hidratación (low carb)', 'Movimiento 7 días adaptado a tu nivel', 'Plan de entrenamiento 1 semana personalizado (casa o gym, por WhatsApp)']
  }, {
    title: 'ALMA',
    icon: <BrainIcon className="w-6 h-6 text-amber" data-id="element-141" />,
    items: ['Estructura diaria completa (mañana + día + noche)', 'Gratitud mañana y noche', 'Afirmaciones escritas alineadas con los 7 chakras', "Journaling 'Observador 3 columnas'", 'Protocolo de sueño', 'Diagnóstico de autoestima (10 preguntas + reflexión + plan)']
  }, {
    title: 'SISTEMA',
    icon: <LayoutListIcon className="w-6 h-6 text-offwhite" data-id="element-142" />,
    items: ['Tracker Google Sheets (2 minutos por día)', "PDF 'RESET 7D — Cuerpo + Alma'", 'Acompañamiento por WhatsApp durante 7 días']
  }];
  return <section id="includes" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-143">
      <div className="max-w-6xl mx-auto px-6" data-id="element-144">
        <FadeIn className="text-center mb-10 md:mb-16" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-4" data-id="element-146">
            Qué Incluye
          </h2>
          <p className="text-offwhite-dim text-lg" data-id="element-147">
            Todo lo que necesitás para ejecutar sin pensar.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-148">
          {categories.map((category, idx) => <FadeIn key={idx} delay={idx * 0.2} direction="up" className="bg-charcoal border border-charcoal-light rounded-sm p-8 hover:border-sand/30 transition-colors" data-id="element-149">
              <div className="flex items-center gap-4 mb-8 pb-4 border-b border-charcoal-light" data-id="element-150">
                <div className="bg-charcoal-dark p-3 rounded-sm border border-charcoal-light" data-id="element-151">
                  {category.icon}
                </div>
                <h3 className="text-xl font-heading font-bold text-offwhite tracking-wider" data-id="element-152">
                  {category.title}
                </h3>
              </div>
              <ul className="space-y-5" data-id="element-153">
                {category.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-154">
                    <CheckIcon className="w-5 h-5 text-sand/70 shrink-0 mt-0.5" data-id="element-155" />
                    <span className="text-offwhite-dim text-sm leading-relaxed" data-id="element-156">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}